@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.healthkit.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ifaandroid.feature.healthkit.generated.resources/"

@delegate:ResourceContentHash(-1_562_688_567)
internal val Res.drawable.ic_apple_health: DrawableResource by lazy {
      DrawableResource("drawable:ic_apple_health", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_apple_health.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_963_708_245)
internal val Res.drawable.icn_health_connect: DrawableResource by lazy {
      DrawableResource("drawable:icn_health_connect", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/icn_health_connect.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icn_health_connect.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/icn_health_connect.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_apple_health", Res.drawable.ic_apple_health)
  map.put("icn_health_connect", Res.drawable.icn_health_connect)
}
